/**
 * Config central do frontend (produto neutro — nenhum dominio de cliente
 * cravado no codigo).
 *
 * API_URL: base da API. Vem de REACT_APP_API_URL no build/ambiente.
 * Fallback '' = mesma origem (o proxy/nginx do deploy roteia as rotas da API
 * no proprio dominio — e o comportamento de producao).
 */
export const API_URL = process.env.REACT_APP_API_URL || '';
